"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesignateShieldERC20RecipientStep = void 0;
const step_1 = require("../step");
const token_1 = require("../../utils/token");
class DesignateShieldERC20RecipientStep extends step_1.Step {
    config = {
        name: 'Designate Shield ERC20s Recipient',
        description: 'Designates ERC20s to shield into a private RAILGUN balance.',
    };
    toAddress;
    erc20Infos;
    constructor(toAddress, erc20Infos) {
        super();
        this.toAddress = toAddress;
        this.erc20Infos = erc20Infos;
    }
    async getStepOutput(input) {
        const { erc20AmountsForStep, unusedERC20Amounts } = this.getValidInputERC20Amounts(input.erc20Amounts, [
            erc20Amount => this.erc20Infos.find(erc20Info => (0, token_1.compareERC20Info)(erc20Amount, erc20Info)) != null,
        ], {});
        const outputERC20Amounts = erc20AmountsForStep.map(erc20Amount => ({
            ...erc20Amount,
            recipient: this.toAddress,
        }));
        return {
            crossContractCalls: [],
            outputERC20Amounts: [...outputERC20Amounts, ...unusedERC20Amounts],
            outputNFTs: input.nfts,
        };
    }
}
exports.DesignateShieldERC20RecipientStep = DesignateShieldERC20RecipientStep;
